import { Injectable } from '@angular/core';

import { ConfigurationService } from '../../services/configuration.service';

@Injectable()
export class MasterCountryService extends ConfigurationService {

    public modelPath = 'configuration/countries';

    getDTColumns () {
        const self = this;
        return [{
            name: 'country_id',
            title: 'Country Id',
            visible: false,
            orderable: false,
            searchable: false,
            data: 'country_id'
        }, {
            name: 'country_name',
            title: 'Country Name',
            data: 'country_name'
        }, {
            title: 'Status',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-country')) {
                    return `<div class="custom-control custom-checkbox">
						<input class="custom-control-input" data-modelPk="checkbox_${full.country_id}" id="checkbox_${full.country_id}" type="checkbox" />
						<label class="custom-control-label" for="checkbox_${full.country_id}"></label>
						</div>`;
                }
                return `<label class="label label-${full.status === 1 ? 'success' : 'danger'}">
					${full.status === 1 ? 'Active' : 'Inactive'}
					</label>`;
            }
        }, {
            title: 'Action',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-country')) {
                    return `<a href="javascript:void(0)" data-modelPk="${full.country_id}" class="btn btn-secondary">
						<i class="icon-pencil" data-modelPk="${full.country_id}"></i>
						</a>`;
                }
                return '';
            }
        }];
    }
}
